var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForwardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M10.4155 1.72034L13.9226 4.70636C15.3075 5.88551 16 6.47509 16 7.23458C16 7.99414 15.3075 8.58369 13.9226 9.76287L10.4155 12.7489C9.78332 13.2871 9.46727 13.5563 9.20665 13.4441C8.94602 13.332 8.94602 12.927 8.94602 12.1168V10.1341C5.76762 10.1341 2.32434 11.5838 1 14C1 6.26811 5.70876 4.33516 8.94602 4.33516V2.35241C8.94602 1.54226 8.94602 1.13719 9.20665 1.02509C9.46727 0.912994 9.78332 1.18211 10.4155 1.72034Z",
    stroke: "#FAFAFA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardIcon);
export default __webpack_public_path__ + "static/media/forwardIcon.ba066cd7ee5352a2ff225812eaedd7cb.svg";
export { ForwardRef as ReactComponent };